import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const buttonStyle = style({
  pointerEvents: "auto",
  height: "auto",
  padding: theme.spacings.xs,
  maxWidth: rem(200),
  alignSelf: "flex-end",
});

export const textStyle = style({
  whiteSpace: "wrap",
  lineHeight: 1.15,
});
